// Sorts dropdown filter options in A-Z order
export const sortedByKey = (a, b) => a.key.localeCompare(b.key);
